import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController } from 'ionic-angular';
import { TakeawayServices } from "../../services";
import { Globals } from "../../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { AngularFirestore } from 'angularfire2/firestore';

/**
 * Generated class for the TakeawayOrdersDeletePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'takeaway-orders-delete',
  templateUrl: 'takeaway-orders-delete.html',
})

export class TakeawayOrdersDeletePage {

  tables_array_take_away = [];
  activeAllDelete: boolean = false;
  loading_tables: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals: Globals,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public translate: TranslateService,
    public afs: AngularFirestore) {

  }

  async ionViewWillEnter() {
    this.loading_tables = false;
    this.tables_array_take_away = await this.takeawayServices.getTakeawayTables2Delete(this.globals.restaurant_uid);

    this.loading_tables = true;
  }

  getDeliveryImage(table) {
    if (table != undefined) {
      const delivery = this.takeawayServices.deliveries.find(t => t.name == table);
      if (delivery != undefined) {
        return delivery.img;
      }
    }
  }

  activeAll() {
    for (let table of this.tables_array_take_away) {
      if (!this.activeAllDelete) {
        table.active_delete = true;
      } else {
        table.active_delete = false;
      }
    }
  }

  delete() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('tk-eliminando-tk-delivery')
    });
    loadingPopup.present();

    for (let table of this.tables_array_take_away) {
      if (table.active_delete) {
        this.afs.collection('tables').doc(table.UID).delete();
      }
    }

    loadingPopup.dismiss();
    this.navCtrl.pop();

  }



}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-orders/takeaway-orders-delete/takeaway-orders-delete.ts